<template>
  <div id="app">
    <Header></Header>
    <main class="main-content">
      <router-view/>
    </main>
    <Footer></Footer>
    <GoTop></GoTop>
    <a class="icp-float" href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">粤ICP备2024275829号</a>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* CRMEB风格全局样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  scroll-behavior: smooth;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  margin-top: 94px; /* Header高度 */
}

/* CRMEB风格色彩变量 */
:root {
  --primary-color: #8ab4ff;
  --primary-color-hover: #40a9ff;
  --primary-color-active: #096dd9;
  --success-color: #52c41a;
  --warning-color: #faad14;
  --error-color: #f5222d;
  --text-color: #000000d9;
  --text-color-secondary: #00000073;
  --text-color-disabled: #00000040;
  --border-color: #d9d9d9;
  --border-color-split: #f0f0f0;
  --background-color: #fafafa;
  --box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  --border-radius: 6px;
}

/* 通用按钮样式 */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 4px 15px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5715;
  text-align: center;
  text-decoration: none;
  background: transparent;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  user-select: none;
  touch-action: manipulation;
}

.btn:hover {
  text-decoration: none;
}

.btn:focus {
  outline: 0;
}

.btn-primary {
  color: #fff;
  background: var(--primary-color);
  border-color: var(--primary-color);
}

.btn-primary:hover {
  color: #fff;
  background: var(--primary-color-hover);
  border-color: var(--primary-color-hover);
}

.btn-primary:active {
  color: #fff;
  background: var(--primary-color-active);
  border-color: var(--primary-color-active);
}

.btn-lg {
  height: 40px;
  padding: 6.4px 15px;
  font-size: 16px;
}

.btn-sm {
  height: 24px;
  padding: 0 7px;
  font-size: 14px;
}

.btn-block {
  width: 100%;
}

/* 卡片样式 */
.card {
  background: #fff;
  border: 1px solid var(--border-color-split);
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
  transition: box-shadow 0.3s;
}

.card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.card-header {
  padding: 16px 24px;
  border-bottom: 1px solid var(--border-color-split);
  font-size: 16px;
  font-weight: 500;
}

.card-body {
  padding: 24px;
}

.card-footer {
  padding: 12px 24px;
  border-top: 1px solid var(--border-color-split);
  background: var(--background-color);
}

/* 容器样式 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

.container-fluid {
  width: 100%;
  padding: 0 15px;
}

/* 网格系统 */
.row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
}

.col {
  flex: 1;
  padding: 0 15px;
}

/* 文本对齐 */
.text-left { text-align: left; }
.text-center { text-align: center; }
.text-right { text-align: right; }

/* 显示/隐藏 */
.d-none { display: none !important; }
.d-block { display: block !important; }
.d-flex { display: flex !important; }
.d-inline { display: inline !important; }
.d-inline-block { display: inline-block !important; }

/* 间距 */
.m-0 { margin: 0 !important; }
.mt-0 { margin-top: 0 !important; }
.mr-0 { margin-right: 0 !important; }
.mb-0 { margin-bottom: 0 !important; }
.ml-0 { margin-left: 0 !important; }

.m-1 { margin: 8px !important; }
.mt-1 { margin-top: 8px !important; }
.mr-1 { margin-right: 8px !important; }
.mb-1 { margin-bottom: 8px !important; }
.ml-1 { margin-left: 8px !important; }

.m-2 { margin: 16px !important; }
.mt-2 { margin-top: 16px !important; }
.mr-2 { margin-right: 16px !important; }
.mb-2 { margin-bottom: 16px !important; }
.ml-2 { margin-left: 16px !important; }

.m-3 { margin: 24px !important; }
.mt-3 { margin-top: 24px !important; }
.mr-3 { margin-right: 24px !important; }
.mb-3 { margin-bottom: 24px !important; }
.ml-3 { margin-left: 24px !important; }

.p-0 { padding: 0 !important; }
.pt-0 { padding-top: 0 !important; }
.pr-0 { padding-right: 0 !important; }
.pb-0 { padding-bottom: 0 !important; }
.pl-0 { padding-left: 0 !important; }

.p-1 { padding: 8px !important; }
.pt-1 { padding-top: 8px !important; }
.pr-1 { padding-right: 8px !important; }
.pb-1 { padding-bottom: 8px !important; }
.pl-1 { padding-left: 8px !important; }

.p-2 { padding: 16px !important; }
.pt-2 { padding-top: 16px !important; }
.pr-2 { padding-right: 16px !important; }
.pb-2 { padding-bottom: 16px !important; }
.pl-2 { padding-left: 16px !important; }

.p-3 { padding: 24px !important; }
.pt-3 { padding-top: 24px !important; }
.pr-3 { padding-right: 24px !important; }
.pb-3 { padding-bottom: 24px !important; }
.pl-3 { padding-left: 24px !important; }

/* 标题样式 */
h1, h2, h3, h4, h5, h6 {
  margin: 0 0 16px 0;
  font-weight: 500;
  line-height: 1.35;
}

h1 { font-size: 38px; }
h2 { font-size: 30px; }
h3 { font-size: 24px; }
h4 { font-size: 20px; }
h5 { font-size: 16px; }
h6 { font-size: 14px; }

/* 段落样式 */
p {
  margin: 0 0 16px 0;
  line-height: 1.5715;
}

/* 链接样式 */
a {
  color: var(--primary-color);
  text-decoration: none;
  transition: color 0.3s;
}

a:hover {
  color: var(--primary-color-hover);
  text-decoration: none;
}

/* 表单元素 */
.form-control {
  display: block;
  width: 100%;
  height: 32px;
  padding: 4px 11px;
  font-size: 14px;
  line-height: 1.5715;
  color: var(--text-color);
  background: #fff;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius);
  transition: border-color 0.3s, box-shadow 0.3s;
}

.form-control:focus {
  border-color: var(--primary-color-hover);
  outline: 0;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

/* 响应式断点 */
@media (max-width: 575.98px) {
  .d-xs-none { display: none !important; }
  .d-xs-block { display: block !important; }
}

@media (min-width: 576px) {
  .d-sm-none { display: none !important; }
  .d-sm-block { display: block !important; }
}

@media (min-width: 768px) {
  .d-md-none { display: none !important; }
  .d-md-block { display: block !important; }
}

@media (min-width: 992px) {
  .d-lg-none { display: none !important; }
  .d-lg-block { display: block !important; }
}

@media (min-width: 1200px) {
  .d-xl-none { display: none !important; }
  .d-xl-block { display: block !important; }
}

/* 动画效果 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.slide-enter-active, .slide-leave-active {
  transition: transform 0.3s;
}
.slide-enter, .slide-leave-to {
  transform: translateX(100%);
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 选中文本样式 */
::selection {
  background: rgba(24, 144, 255, 0.2);
  color: inherit;
}

::-moz-selection {
  background: rgba(24, 144, 255, 0.2);
  color: inherit;
}

/* 图片响应式 */
img {
  max-width: 100%;
  height: auto;
}

.img-responsive {
  max-width: 100%;
  height: auto;
}

/* 阴影效果 */
.shadow-sm {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05) !important;
}

.shadow {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

.shadow-lg {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
}

/* 位置工具类 */
.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

/* 溢出处理 */
.overflow-hidden {
  overflow: hidden !important;
}

.overflow-auto {
  overflow: auto !important;
}

/* 圆角 */
.rounded {
  border-radius: var(--border-radius) !important;
}

.rounded-lg {
  border-radius: 8px !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

/* 边框 */
.border {
  border: 1px solid var(--border-color) !important;
}

.border-top {
  border-top: 1px solid var(--border-color) !important;
}

.border-right {
  border-right: 1px solid var(--border-color) !important;
}

.border-bottom {
  border-bottom: 1px solid var(--border-color) !important;
}

.border-left {
  border-left: 1px solid var(--border-color) !important;
}

.border-0 {
  border: 0 !important;
}

/* 颜色工具类 */
.text-primary {
  color: var(--primary-color) !important;
}

.text-success {
  color: var(--success-color) !important;
}

.text-warning {
  color: var(--warning-color) !important;
}

.text-danger {
  color: var(--error-color) !important;
}

.text-muted {
  color: var(--text-color-secondary) !important;
}

.bg-primary {
  background-color: var(--primary-color) !important;
}

.bg-light {
  background-color: var(--background-color) !important;
}

.bg-white {
  background-color: #fff !important;
}

/* 过渡动画 */
.transition {
  transition: all 0.3s ease !important;
}

/* Flex布局工具类 */
.d-flex {
  display: flex !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row {
  flex-direction: row !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

/* 宽度高度工具类 */
.w-25 { width: 25% !important; }
.w-50 { width: 50% !important; }
.w-75 { width: 75% !important; }
.w-100 { width: 100% !important; }
.w-auto { width: auto !important; }

.h-25 { height: 25% !important; }
.h-50 { height: 50% !important; }
.h-75 { height: 75% !important; }
.h-100 { height: 100% !important; }
.h-auto { height: auto !important; }

/* 兼容Bootstrap类名 */
.visible-xs {
  display: block !important;
}

.hidden-xs {
  display: none !important;
}

@media (min-width: 768px) {
  .visible-xs {
    display: none !important;
  }
  .hidden-xs {
    display: block !important;
  }
}

/* 自定义滚动容器 */
.scroll-container {
  overflow-x: auto;
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}

/* 加载动画 */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading {
  animation: spin 1s linear infinite;
}

/* 淡入动画 */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.fade-in {
  animation: fadeIn 0.6s ease-out;
}

/* 背景渐变 */
.gradient-primary {
  background: linear-gradient(135deg, #8ab4ff 0%, #5e9eff 100%);
}

.gradient-blue {
  background: linear-gradient(135deg, #8ab4ff 0%, #5e9eff 100%);
}

/* Z-index层级 */
.z-index-1 { z-index: 1; }
.z-index-2 { z-index: 2; }
.z-index-3 { z-index: 3; }
.z-index-10 { z-index: 10; }
.z-index-100 { z-index: 100; }
.z-index-1000 { z-index: 1000; }

/* 备案号悬浮栏 */
.icp-float {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 7px 16px;
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
  line-height: 1.5;
  text-align: center;
  text-decoration: none;
  background: rgba(5, 5, 5, 0.72);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  transition: color 0.2s ease;
}

.icp-float:hover {
  color: #fff;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue